export default __webpack_public_path__ + "static/media/telegram-team-link.734957d2.svg";